module.exports = __webpack_public_path__ + "img/user__avatar.464bea44.jpg";